function Danger() {
    return(
    <svg className="danger-icon" id="Error_big" data-name="Error big" xmlns="http://www.w3.org/2000/svg" width="23.515" height="23.515" viewBox="0 0 23.515 23.515">
        <path id="Path_967" data-name="Path 967" d="M14.121,1.121a3,3,0,0,0-4.243,0L1.121,9.879a3,3,0,0,0,0,4.243l8.757,8.757a3,3,0,0,0,4.243,0l8.757-8.757a3,3,0,0,0,0-4.243ZM11,6a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Zm-.25,11.25A1.25,1.25,0,1,1,12,18.5,1.25,1.25,0,0,1,10.75,17.25Z" transform="translate(-0.243 -0.243)" fill="#dc2417" fillRule="evenodd"/>
    </svg>
    )
}

export default Danger;